const support = {
  header: 'מנהל',
  howCreateUser: 'כיצד ליצור משתמש חדש?',
  explainHowCreateaUser:
    'To create a new user, log in to the web admin, click the "משתמשים" tab in the left side menu, click "New User", enter their details and click "הוסף" on the bottom.',

  howCreateaJob: 'כיצד להזמין הזמנות?',
  explainHowCreateaJob:
    'כדי להזמין בחר ב"הזמנות" בתפריט הראשי ואז לחץ על "הזמנה חדשה". מלא את המידע הרלוונטי ולחץ על "הזמן".',

  howCreateaJobManual: 'כיצד לנתב הזמנות באופן ידני?',
  explainHowCreateaJobManual:
    'בתפריט השמאלי\nלחץ על "הזמנות". כדי לנתב את ההזמנות הרצויות לנסיעות משותפות אופטימליות\nבחר את ההזמנות על ידי לחיצה על הריבוע הקטן שמשמאל להזמנות שברצונך לאחד (או הריבוע שמשמאל ל"כל הדף/כל התוצאות") ולאחר מכן לחץ על "נתב".',

  howMakeReports: 'כיצד לצפות בדוחות?',
  explainMakeReports: 'דוחות מתקדמים ניתן למצוא תחת לשונית "דוחות" בפורטל.',

  whereGuide: 'היכן ניתן למצוא מדריך משתמש?',
  explaneWhereGuideStart: 'אם אתה זקוק לעזרה בתחילת העבודה\nאתה יכול להסתכל על',
  explaneWhereGuideEnd: 'מדריך המשתמש למנהל',

  infoHeader: 'מה אם אני צריך לדבר עם מישהו?',
  infoBody1: 'תוכל להגיע אלינו בטלפון:',
  infoBody2: 'או באימייל:',
  infoBody3: 'צוות שירות הלקוחות שלנו זמין 24/7 לענות על כל שאלה',
};

export default support;
